import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, AttributionControl } from 'react-leaflet';
import L from 'leaflet';

const ICONS = {
  days_out: '#C24F41',
  heritage: '#2A5446',
  outdoors: '#E8A34A',
  food_drink: '#B85C7E',   // dusty rose — distinguishes places-to-eat from days-out pins
  accommodation: '#7BAFD4',
  event: '#5C5856',
};

function pin(color, isMember) {
  const ring = isMember ? `<circle cx="14" cy="14" r="13" fill="none" stroke="${color}" stroke-width="2" stroke-dasharray="3 3"/>` : '';
  const html = `
    <svg width="28" height="36" viewBox="0 0 28 36" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 0C6.27 0 0 6.27 0 14c0 9.42 12.51 21.13 13.06 21.62a1.4 1.4 0 0 0 1.88 0C15.49 35.13 28 23.42 28 14 28 6.27 21.73 0 14 0z" fill="${color}"/>
      <circle cx="14" cy="14" r="5" fill="#FAF8F5"/>
      ${ring}
    </svg>`;
  return L.divIcon({ html, className: 'gl-pin', iconSize: [28, 36], iconAnchor: [14, 36], popupAnchor: [0, -30] });
}

export default function CountyMap({ items = [], height = 520, onSelect }) {
  return (
    <div className="rounded-3xl overflow-hidden border border-charcoal/10" data-testid="county-map" style={{ height }}>
      {/* attributionControl is configured to suppress Leaflet's default
          "Leaflet" link and the upstream OSM string (which on some clients
          includes a 🇺🇦 emoji). We render only our own neutral credit. */}
      <MapContainer center={[52.65, -1.15]} zoom={10} style={{ height: '100%', width: '100%' }} scrollWheelZoom={false} attributionControl={false}>
        <AttributionControl position="bottomright" prefix={false} />
        <TileLayer
          attribution="Map data © OpenStreetMap contributors"
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {items.filter((i) => i.lat && i.lng).map((i) => (
          <Marker
            key={i.id || i.slug}
            position={[i.lat, i.lng]}
            icon={pin(ICONS[i.category] || ICONS.days_out, i.is_featured_member)}
            eventHandlers={onSelect ? { click: () => onSelect(i) } : {}}
          >
            <Popup>
              <div style={{ minWidth: 200 }}>
                <strong style={{ fontFamily: 'Fraunces, serif', fontSize: 16 }}>{i.name}</strong>
                <div style={{ fontSize: 12, color: '#5C5856', marginTop: 4 }}>{i.town || i.address || 'Leicestershire'}</div>
                <a href={`/explore/${i.slug}`} style={{ display: 'inline-block', marginTop: 8, color: '#C24F41', fontWeight: 600, fontSize: 13 }}>View →</a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
